<!-- 创建售卖商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "traderCouponTemplateCode": "GCSH3FI1YNDN",
                "traderCode": "NWTSZY49BH67",
                "sellNum": 100,
                "sellMoney": 0.01,
                "sellRemark": "测试",
                "sellTime": "2018-04-16 09:00:00",
                },
            responseCode: {
                "data": {
                    "sellBillId":"10012",
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台售卖电子券给商家",
                t_url: this.commonUrls.test+"sellCoupon",
                p_url: this.commonUrls.prod+"sellCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCouponTemplateCode', info2: '是', info3: 'String', info4: '电子券模板代码' },
                        { info1: 'traderCode', info2: '是', info3: 'String', info4: '商家编号' },
                        { info1: 'sellNum', info2: '是', info3: 'int', info4: '销售数量（最大一次售卖10000张）' },
                        { info1: 'sellMoney', info2: '是', info3: 'decimal', info4: '销售金额（要求：sellNum * realPrice >= sellMoney,其中realprice为创建商家券模板中的realprice，realprice为null时是originalPrice）' },
                        { info1: 'sellRemark', info2: '否', info3: 'String', info4: '销售备注（最多100字符）' },
                        { info1: 'sellTime', info2: '是', info3: 'String', info4: '销售时间，yyyy-MM-dd HH:mm:ss（同一时间同一商家同一券模板代码会去重）' },
                        { info1: 'transationNum', info2: '否', info3: 'String', info4: '交易单号,同一笔订单，直到返回成功为止，此单号相同；不同笔订单，此单号不同' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'sellBillId', info2: '是', info3: 'String', info4: '销售ID' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/sellCoupon.vue